// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setXAxisDate = createAction('[Scatter Plot] Set X Axis Date', props());
